import { SimNaoEnum } from 'components/form'
import { EstrategiaVacinacaoEnum, OrigemDadoEnum, RegistroVacinacaoInput } from 'graphql/types.generated'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { VacinacaoRetificacaoModel } from 'view/retificacao-atendimento/model-retificacaoAtendimento'

import { RegistroVacinacaoFormModel } from '../model'

export const convertRegistroVacinacaoToInput = (
  listaRegistros: ReadonlyArray<RegistroVacinacaoFormModel>
): RegistroVacinacaoInput[] =>
  listaRegistros?.map((registro) => ({
    tipoRegistroVacinacao: registro.tipoRegistroVacinacao,
    isRegistroAnterior: registro.isRegistroAnterior ?? false,
    imunobiologicoId: registro.imunobiologicoId || registro.outrosImunosImunobiologico?.id,
    estrategiaVacinacao: registro.estrategiaVacinacao?.estrategiaVacinacaoDbEnum,
    doseImunobiologicoId: registro.doseId || registro.outrosImunosDose?.id,
    dataAprazamento: registro.dataAprazamento,
    dataAplicacao: registro.dataAplicacao,
    loteImunobiologicoId: registro.loteImunobiologico?.id,
    viaAdministracaoId: registro.viaAdministracao?.id,
    localAplicacaoVacinacaoId: registro.localAplicacaoVacinacao?.id,
    observacoes: registro.observacoes,
    grupoAtendimentoId: registro.grupoAtendimento?.id,
    loteImunobiologicoCadastro:
      !registro.loteImunobiologico?.id || (registro.isRegistroAnterior && registro.tipoRegistroVacinacao == null)
        ? {
            loteNome: registro.loteNome,
            fabricanteNome: registro.loteFabricante?.nome,
            fabricanteId: registro.loteFabricante?.id,
            dataValidade: registro.loteDataValidade,
          }
        : null,
    isCadastrarNovoLote: registro.isCadastrarNovoLote ?? false,
    isAplicadoExterior: registro.isAplicadoExterior,
    isPesquisaEstrategia: registro.isPesquisaEstrategia ?? false,
    cid10MotivoIndicacaoId: registro.cid10MotivoIndicacao?.id,
    cboPrescritorId: registro.cboPrescritor?.id,
    isPesquisaClinica: registro.isPesquisaClinica === SimNaoEnum.SIM,
    anvisaProtocoloEstudo: registro.anvisaProtocoloEstudo,
    anvisaProtocoloVersao: registro.anvisaProtocoloVersao,
    anvisaNumeroRegistro: registro.anvisaNumeroRegistro,
  }))

export const convertRegistrosVacinacaoQueryRetificacaoToForm = (
  vacinacao: VacinacaoRetificacaoModel,
  finalizadoEm: string
): RegistroVacinacaoFormModel[] =>
  vacinacao.registrosVacinacao.map((registro) => ({
    condicaoMaternal: vacinacao.condicaoMaternal,
    isComunicanteHanseniase: vacinacao.isComunicanteHanseniase ? SimNaoEnum.SIM : SimNaoEnum.NAO,
    isViajante: vacinacao.isViajante,
    loteImunobiologico: !registro.isRegistroAnterior && registro.loteImunobiologico,
    loteNome: registro.isRegistroAnterior ? registro.loteImunobiologico?.lote : null,
    loteFabricante: registro.isRegistroAnterior && registro.loteImunobiologico?.fabricante,
    dataAplicacao: dateAsYyyyMmDd(registro.dataAplicacao),
    dataAprazamento: dateAsYyyyMmDd(registro.dataAprazamento),
    dataRegistro: finalizadoEm,
    viaAdministracao: registro.viaAdministracao,
    estrategiaVacinacao: !registro.isRegistroAnterior ? registro.estrategiaVacinacao : null,
    grupoAtendimento: registro.grupoAtendimento,
    localAplicacaoVacinacao: registro.localAplicacaoVacinacao,
    id: registro.id,
    idUnicoRegistro: registro.uuid,
    cboPrescritor: registro.cboPrescritor,
    cid10MotivoIndicacao: registro.cid10MotivoIndicacao,
    anvisaNumeroRegistro: registro.anvisaNumeroRegistro,
    anvisaProtocoloEstudo: registro.anvisaProtocoloEstudo,
    anvisaProtocoloVersao: registro.anvisaProtocoloVersao,
    imunobiologicoId: registro.imunobiologico.id,
    imunobiologicoNome: registro.imunobiologico.nome,
    imunobiologicoSigla: registro.imunobiologico.sigla,
    doseId: registro.doseImunobiologico.id,
    doseNome: registro.doseImunobiologico.nome,
    doseSigla: registro.doseImunobiologico.sigla,
    tipoRegistroVacinacao: registro.tipoRegistroVacinacao.identificador,
    isPesquisaClinica: registro.isPesquisaClinica ? SimNaoEnum.SIM : SimNaoEnum.NAO,
    isPesquisaEstrategia:
      registro.isRegistroAnterior &&
      registro.estrategiaVacinacao?.estrategiaVacinacaoDbEnum === EstrategiaVacinacaoEnum.PESQUISA,
    origemDados: OrigemDadoEnum.PEC,
    isAplicadoExterior: registro.isAplicadoExterior,
    observacoes: registro.observacoes,
    isRegistroAnterior: registro.isRegistroAnterior,
  }))
